import { css } from "@emotion/css";

export const sectionContainer = css`
    justify-content: center;

    > .sds-section-body {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
`;
